/**
 * Constrains a value to the inclusive range `[min, max]`, returning `min`
 * when the range is empty (`max < min`).
 *
 * @example
 * ```ts
 * clamp(120, 0, 100); // 100
 * ```
 */
export function clamp(value: number, min: number, max: number): number {
    if (max < min) {
        return min;
    }
    if (value < min) {
        return min;
    }
    if (value > max) {
        return max;
    }
    return value;
}
